import * as Accounts from './accounts';
import * as S3 from './s3';
import * as Costs from './costs';
import * as Reports from './reports';
import * as Resources from './resources';

export default {
  Accounts,
  S3,
  Costs,
  Reports,
  Resources
};



// WEBPACK FOOTER //
// ./src/api/aws/index.js